'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product16__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.nB;
      break;
    }
    case 1: {
      return $thiz.nJ;
      break;
    }
    case 2: {
      return $thiz.nK;
      break;
    }
    case 3: {
      return $thiz.nL;
      break;
    }
    case 4: {
      return $thiz.nM;
      break;
    }
    case 5: {
      return $thiz.nN;
      break;
    }
    case 6: {
      return $thiz.nO;
      break;
    }
    case 7: {
      return $thiz.nP;
      break;
    }
    case 8: {
      return $thiz.nQ;
      break;
    }
    case 9: {
      return $thiz.nC;
      break;
    }
    case 10: {
      return $thiz.nD;
      break;
    }
    case 11: {
      return $thiz.nE;
      break;
    }
    case 12: {
      return $thiz.nF;
      break;
    }
    case 13: {
      return $thiz.nG;
      break;
    }
    case 14: {
      return $thiz.nH;
      break;
    }
    case 15: {
      return $thiz.nI;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 15)"));
    }
  }
}
export { $f_s_Product16__productElement__I__O as $f_s_Product16__productElement__I__O };
